import React from 'react';
import './SingleTeacherDetails.css';
import { Avatar, Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import DocumentLogo from '../../../../../assets/Admin/document-logo.svg';

const SingleTeacherDetails = ({ teacherDetails, bankDetails, commentList }) => {
  console.log(teacherDetails);
  console.log(bankDetails);

  // Function to format text by replacing underscores with spaces and capitalizing first letter of each word
  const formatText = text => {
    if (!text) return '';

    // Replace underscores with spaces
    const withSpaces = text.replace(/_/g, ' ');

    // Capitalize first letter of each word
    return withSpaces
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <Box className="flex flex-col items-start gap-[19px] bg-[#FFF] rounded-[8px]">
      <Box className="flex flex-col gap-1 w-[100%]">
        <Typography className="personal-information-text">Personal Information</Typography>
        <Box className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">First Name</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.first_name ? formatText(teacherDetails?.first_name) : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Last Name</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.last_name ? formatText(teacherDetails?.last_name) : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Email</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.email ? teacherDetails?.email : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Phone Number</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.phone_no ? teacherDetails?.phone_no : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Current Location</Typography>
            <Typography className="personal-information-value-text">
              {(() => {
                const city = teacherDetails?.city;
                const location = teacherDetails?.current_location;
                if (city && location && city !== location) {
                  return formatText(`${city}, ${location}`);
                }
                if (city) {
                  return formatText(city);
                }
                if (location) {
                  return formatText(location);
                }
                return '---';
              })()}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Date of Birth</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.dob ? dayjs(teacherDetails?.dob).format('DD MMM YYYY') : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Gender</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.gender ? formatText(teacherDetails?.gender) : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Registration On</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.registration_date
                ? dayjs(teacherDetails?.registration_date).format('DD MMM YYYY')
                : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Document</Typography>
            <Box className="flex items-center gap-2">
              {/* Document Logo */}
              <img src={DocumentLogo} alt="Document" className="w-[18] h-[18]" />

              {/* Document Name */}
              <Typography className="personal-information-value-text">Document.pdf</Typography>

              {/* View Button */}
              {(() => {
                const fileUrl = teacherDetails.document;
                const fileExtension = fileUrl?.split('.').pop()?.toLowerCase();
                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(
                  fileExtension
                );

                if (isImage) {
                  return (
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      download={false}
                      className="view-button"
                    >
                      View
                    </a>
                  );
                } else {
                  return (
                    <a
                      href={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(fileUrl)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="view-button"
                    >
                      View
                    </a>
                  );
                }
              })()}
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className="flex flex-col gap-1 w-[100%]">
        <Typography className="personal-information-text">Coupon Information</Typography>
        <Box className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Coupon Used</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.used_coupon_code
                ? teacherDetails?.used_coupon_code
                : 'No Coupon used'}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className="flex flex-col gap-1 w-[100%]">
        <Typography className="personal-information-text">Bank Information</Typography>
        <Box className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Full Name</Typography>
            <Typography className="personal-information-value-text">
              {bankDetails?.full_name ? bankDetails?.full_name : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Address</Typography>
            <Typography className="personal-information-value-text">
              {bankDetails?.address ? bankDetails?.address : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">IBAN Number</Typography>
            <Typography className="personal-information-value-text">
              {bankDetails?.IBAN_no ? bankDetails?.IBAN_no : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Bank Statement</Typography>
            <Box className="flex items-center gap-2">
              {/* Document Logo */}
              <img src={DocumentLogo} alt="Document" className="w-[18] h-[18]" />

              {/* Document Name */}
              <Typography className="personal-information-value-text">
                Bank-Statement.pdf
              </Typography>

              {/* View Button */}
              {(() => {
                const fileUrl = bankDetails.statement_url;
                const fileExtension = fileUrl?.split('.').pop()?.toLowerCase();
                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(
                  fileExtension
                );

                if (isImage) {
                  return (
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      download={false}
                      className="view-button"
                    >
                      View
                    </a>
                  );
                } else {
                  return (
                    <a
                      href={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(fileUrl)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="view-button"
                    >
                      View
                    </a>
                  );
                }
              })()}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className="flex flex-col gap-1 w-[100%]">
        <Typography className="personal-information-text">Education Background</Typography>
        <Box className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Degree Name</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.degree_name ? teacherDetails?.degree_name : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Highest Qualification</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.highest_qualification
                ? formatText(teacherDetails?.highest_qualification)
                : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Institution</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.institute ? teacherDetails?.institute : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Passing Year</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.passing_year ? teacherDetails?.passing_year : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">CV</Typography>
            <Box className="flex items-center gap-2">
              {/* Document Logo */}
              <img src={DocumentLogo} alt="Document" className="w-[18] h-[18]" />

              {/* Document Name */}
              <Typography className="personal-information-value-text">CV.pdf</Typography>

              {/* View Button */}
              {(() => {
                const fileUrl = teacherDetails.cv;
                const fileExtension = fileUrl?.split('.').pop()?.toLowerCase();
                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(
                  fileExtension
                );

                if (isImage) {
                  return (
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      download={false}
                      className="view-button"
                    >
                      View
                    </a>
                  );
                } else {
                  return (
                    <a
                      href={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(fileUrl)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="view-button"
                    >
                      View
                    </a>
                  );
                }
              })()}
            </Box>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Academic Transcript</Typography>
            <Box className="flex items-center gap-2">
              {/* Document Logo */}
              <img src={DocumentLogo} alt="Document" className="w-[18] h-[18]" />

              {/* Document Name */}
              <Typography className="personal-information-value-text">
                Academic-Transcript.pdf
              </Typography>

              {/* View Button */}
              {(() => {
                const fileUrl = teacherDetails.degree;
                const fileExtension = fileUrl?.split('.').pop()?.toLowerCase();
                const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(
                  fileExtension
                );

                if (isImage) {
                  return (
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      download={false}
                      className="view-button"
                    >
                      View
                    </a>
                  );
                } else {
                  return (
                    <a
                      href={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(fileUrl)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="view-button"
                    >
                      View
                    </a>
                  );
                }
              })()}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className="flex flex-col gap-1 w-[100%]">
        <Typography className="personal-information-text">Area of Specialisation</Typography>
        <Box className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Levels to Teach</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.level_of_teaching && teacherDetails.level_of_teaching.length > 0
                ? teacherDetails.level_of_teaching.map(level => formatText(level)).join(', ')
                : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Years of Experience</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.years_of_experience ? teacherDetails?.years_of_experience : '---'}
            </Typography>
          </Box>
          <Box className="flex flex-col gap-2 w-[30%]">
            <Typography className="personal-information-key-text">Teaching Languages</Typography>
            <Typography className="personal-information-value-text">
              {teacherDetails?.teaching_lang && teacherDetails.teaching_lang.length > 0
                ? teacherDetails.teaching_lang.join(', ')
                : '---'}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className="flex flex-col gap-1 w-[100%]">
        <Typography className="personal-information-text">Subjects</Typography>
        <Box className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
          {teacherDetails?.subjects && teacherDetails.subjects.length > 0 ? (
            <Box className="flex flex-col w-full">
              {teacherDetails.subjects.map(subject => (
                <Box key={subject.id} className="subject-category-container">
                  <Typography className="subject-category-title">{subject.title}</Typography>
                  {subject.tags && subject.tags.length > 0 && (
                    <Box className="subject-tags-container">
                      {subject.tags.map(tag => (
                        <Box key={tag.id} className="subject-tag">
                          {tag.title}
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          ) : (
            <Typography className="personal-information-value-text">---</Typography>
          )}
        </Box>
      </Box>

      {commentList.length > 0 && (
        <Box className="flex flex-col gap-1 w-[100%]">
          <Typography className="personal-information-text">Comments</Typography>
          <Box className="flex flex-wrap items-center content-center gap-2 self-stretch p-3 rounded-md bg-[#FAFAFA] w-[100%]">
            {commentList.length > 0 &&
              commentList?.map((item, index) => {
                return (
                  <Box
                    key={index}
                    className="flex flex-wrap items-center content-center gap-6 self-stretch p-3 rounded-md bg-[#FFF] w-[100%]"
                  >
                    <Box className="flex items-start gap-4 w-full">
                      <Avatar
                        src={item?.profile_image || '/broken-image.jpg'}
                        alt="admin"
                        sx={{ width: '50px', height: '50px' }}
                      />
                      <Box className="flex flex-col gap-2 w-full">
                        <Box className="flex items-center gap-10">
                          <div className="personal-information-value-text">
                            {item?.first_name} {item?.last_name}
                          </div>
                          <div className="day-time-text">
                            {dayjs(item?.created_at)
                              .format('dddd h:mma')
                              .replace(/AM|PM/i, match => match.toLowerCase())}
                          </div>
                        </Box>
                        <div className="personal-information-value-text">{item?.comment}</div>
                      </Box>
                    </Box>
                  </Box>
                );
              })}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SingleTeacherDetails;
